var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"triangle",class:{
    triangleBottom: _vm.direction === 'bottom',
    triangleTop: _vm.direction === 'top',
  },style:({ left: _vm.left + 'px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }